'use client'

import { useTranslation } from '@web/src/lib/intl/react'
import React, { useMemo } from 'react'
import { HolidayPortal } from '../holiday-portal'
import { useHolidayResponsiveValue } from '../use-holiday-responsive-value'

type SnowflakeType = 'penis' | 'vulva'

const PenisSnowflake: React.FC<{ size: number; color: string; glowColor: string }> = ({
  size,
  color,
  glowColor: _glowColor,
}) => {
  const { t } = useTranslation()
  return (
    <svg aria-label={t('Penis Light')} className="christmas-light-svg" height={size} viewBox="0 0 100 100" width={size}>
      <title>{t('Penis Light')}</title>
      <path
        d="m 60.026062,22.78817 c 0.17521,0.0422 0.64112,0.156447 1.03535,0.253872 1.229819,0.303936 3.18696,1.417633 4.277422,2.434037 1.320356,1.230688 2.150018,2.516154 2.669174,4.135572 1.246105,3.887025 -0.161849,8.457065 -3.384806,10.986655 -0.963541,0.756249 -2.64739,1.641488 -3.41398,1.794806 -0.26015,0.05203 -0.51506,0.162642 -0.56646,0.245802 -0.0514,0.08316 -0.0929,5.879236 -0.0923,12.880166 l 10e-4,12.728965 0.73356,0.815895 c 0.903527,1.004945 1.291072,2.167337 1.158742,3.475502 -0.178499,1.764559 -2.891312,6.325461 -5.017092,8.434964 -1.70038,1.687363 -2.69313,2.166306 -4.48898,2.165661 -1.84136,-6.62e-4 -2.804,-0.469705 -4.54812,-2.216073 -2.24812,-2.251024 -4.79148,-6.593192 -4.96119,-8.470027 -0.12041,-1.331701 0.26454,-2.447094 1.1837,-3.429748 l 0.70689,-0.755721 0.008,-12.756309 c 0.005,-7.01597 -0.0335,-12.798205 -0.0847,-12.849412 -0.0512,-0.05121 -0.54655,-0.251549 -1.10076,-0.445206 -3.55259,-1.241373 -6.104586,-4.456549 -6.676386,-8.411367 -0.5134,-3.550812 1.19936,-7.259123 4.317176,-9.347185 3.14752,-2.107947 6.91977,-2.339009 10.3983,-0.636932 l 0.7566,0.370212 0.75661,-0.370212 c 1.59996,-0.782875 2.45674,-0.99472 4.26087,-1.053537 0.96367,-0.03143 1.89548,-0.02258 2.0707,0.01963 z"
        fill={color}
        stroke="rgba(100, 13, 13, 0.84)"
        strokeWidth="2.5"
      />
    </svg>
  )
}

const VulvaSnowflake: React.FC<{ size: number; color: string; glowColor: string }> = ({
  size,
  color,
  glowColor: _glowColor,
}) => {
  const { t } = useTranslation()
  return (
    <svg aria-label={t('Vulva Light')} className="christmas-light-svg" height={size} viewBox="0 0 100 100" width={size}>
      <title>{t('Vulva Light')}</title>
      <path
        d="M 50.288434,83.930471 C 49.622871,83.614021 48.454329,82.701383 47.655651,81.87425 46.865822,81.056267 45.496061,79.803686 44.611755,79.090731 42.636518,77.498253 41.95698,76.37565 41.323375,73.658284 40.758006,71.23356 40.50203,70.684139 38.7938,68.228758 37.024923,65.686227 36.489082,64.370164 36.348604,62.22327 c -0.103098,-1.57566 -0.0036,-2.231072 0.74763,-4.934866 1.147618,-4.129304 1.232019,-4.891811 0.78223,-7.066763 -0.587902,-2.842792 -0.05988,-5.094946 1.812841,-7.731962 2.878408,-4.053175 7.737952,-15.349352 8.23335,-19.138697 0.08603,-0.657722 0.252911,-1.384341 0.370944,-1.614709 0.270566,-0.528086 1.121375,-0.545965 1.320233,-0.02774 0.379492,0.988923 -0.921303,6.090646 -2.432845,9.541654 l -0.41933,0.957371 0.528932,-0.476845 c 0.290912,-0.262272 1.308982,-1.66243 2.262373,-3.111473 1.931747,-2.936019 2.150836,-3.169399 3.165985,-3.372429 0.988517,-0.197701 1.861451,0.593828 3.373799,3.059155 0.670349,1.092764 1.604307,2.417658 2.075472,2.944221 L 59.026872,32.207558 58.513,30.891167 c -1.267453,-3.246802 -2.142278,-6.400915 -2.190682,-7.898337 -0.04932,-1.52573 -0.0379,-1.557168 0.594316,-1.630156 0.580515,-0.06702 0.658618,0.01627 0.78546,0.837703 0.327594,2.121572 1.164923,5.111274 2.028842,7.244035 2.121278,5.236841 5.17285,11.39014 6.580488,13.269161 1.710953,2.283905 2.219496,4.574519 1.668464,7.515212 -0.432572,2.308499 -0.287969,3.632912 0.750137,6.870507 0.356512,1.111869 0.671378,2.777852 0.75091,3.973125 0.177432,2.666507 -0.221478,3.889454 -2.239533,6.865933 -2.007045,2.960251 -2.147287,3.253613 -2.711028,5.671372 -0.62358,2.674354 -1.180448,3.723435 -2.567697,4.837305 -0.624176,0.501168 -2.106065,1.846932 -3.293091,2.990576 -1.192151,1.148592 -2.640326,2.297946 -3.235265,2.567695 -1.523699,0.690839 -3.598984,0.660656 -5.145887,-0.0748 z m 4.037933,-1.988074 c 2.055481,-1.996477 3.813068,-5.469062 4.908481,-9.698029 0.920321,-3.553001 1.224194,-6.211829 1.225008,-10.718691 8.21e-4,-6.438222 -1.026228,-12.731801 -3.139621,-19.23237 -0.96463,-2.967088 -2.134481,-6.883704 -2.602373,-8.712567 -0.236762,-0.925477 -0.306206,-0.996073 -0.747492,-0.759898 -0.267566,0.143203 -0.980657,0.225349 -1.584636,0.182552 l -1.098145,-0.0778 -0.440414,1.795074 c -0.242228,0.987287 -0.971459,3.464495 -1.620502,5.504896 -1.876516,5.899171 -2.08148,6.644231 -2.732472,9.932762 -0.833594,4.210949 -1.112311,7.073881 -1.112311,11.425507 0,7.080918 1.165945,12.36802 3.787783,17.176054 1.037556,1.90271 3.025101,4.068844 3.733396,4.068844 0.280933,0 0.921415,-0.39885 1.423298,-0.886327 z M 51.38555,76.42334 c -1.610189,-1.610192 -2.487207,-6.4817 -1.983086,-11.015358 0.452175,-4.066485 2.010477,-9.415326 3.100228,-10.641447 0.749021,-0.842764 1.589897,0.598254 2.79448,4.788928 1.760046,6.123097 1.73574,12.260802 -0.06248,15.777953 -0.954586,1.867068 -2.604731,2.334324 -3.849134,1.089924 z m 0.635639,-26.5642 c -0.206733,-0.230371 -0.44353,-0.795818 -0.526236,-1.256551 -0.196066,-1.092167 0.709544,-2.991791 1.426253,-2.991791 0.689566,0 1.623228,1.893745 1.460163,2.961641 -0.23161,1.51687 -1.522255,2.22048 -2.36018,1.286701 z m 2.107877,-19.310387 c 0.358927,-0.547803 0.341786,-0.662 -0.293663,-1.956473 -0.37117,-0.756097 -0.782557,-1.382868 -0.914197,-1.392829 -0.33084,-0.02504 -1.294462,2.000498 -1.306522,2.74631 -0.01312,0.818604 0.403645,1.184752 1.348877,1.184752 0.566526,0 0.890167,-0.161544 1.165505,-0.58176 z"
        fill={color}
        stroke="rgba(11, 90, 1, 0.84)"
        strokeWidth="2.0"
      />
    </svg>
  )
}

const SnowflakeSVG: React.FC<{
  type: SnowflakeType
  size: number
  color: string
  glowColor: string
}> = ({ type, size, color, glowColor }) => {
  switch (type) {
    case 'penis':
      return <PenisSnowflake color={color} glowColor={glowColor} size={size} />
    case 'vulva':
      return <VulvaSnowflake color={color} glowColor={glowColor} size={size} />
    default:
      return null
  }
}

// Generate a wire path that curves down between lights
const generateWirePath = (lightPositions: number[], baseY: number, droopAmount: number): string => {
  if (lightPositions.length < 2) return ''

  const pathParts: string[] = []
  // Start at the first light
  pathParts.push(`M ${lightPositions[0]},${baseY}`)

  // For each pair of lights, create a curve that droops down between them
  for (let i = 0; i < lightPositions.length - 1; i++) {
    const x1 = lightPositions[i]
    const x2 = lightPositions[i + 1]
    const midX = (x1 + x2) / 2
    const midY = baseY + droopAmount // Curve down

    // Use quadratic bezier for smooth downward curve
    pathParts.push(`Q ${midX},${midY} ${x2},${baseY}`)
  }

  return pathParts.join(' ')
}

const ChristmasLightEffect: React.FC = () => {
  const { t } = useTranslation()
  const lightCount = useHolidayResponsiveValue<number>({ base: 12, sm: 20, md: 30 })

  const lights = useMemo(() => {
    return Array.from({ length: lightCount }, (_, i) => {
      // Always start with penis and alternate deterministically
      const type: SnowflakeType = i % 2 === 0 ? 'penis' : 'vulva'
      const position = (i / (lightCount - 1)) * 100 // 0-100% across screen
      const isRed = i % 2 === 0 // Alternate red/green
      const color = isRed ? 'rgba(187, 18, 18, 0.63)' : 'rgba(0, 255, 0, 1)'
      const glowColor = isRed ? 'rgba(187, 18, 18, 1)' : 'rgba(0, 255, 0, 1)'
      const size = 25
      // Alternate delays so adjacent lights are out of phase
      // Even-indexed lights start at 0, odd-indexed lights start at half cycle
      const twinkleSpeed = 2.5
      const twinkleDelay = (i % 2) * (twinkleSpeed / 2) // 0 for even, 0.5 for odd

      return {
        id: i,
        type,
        position,
        color,
        glowColor,
        size,
        twinkleDelay,
        twinkleSpeed,
      }
    })
  }, [lightCount])

  // All lights are at the same Y level (middle of container)
  const lightYPosition = 34 // 10% of container height

  // Calculate wire path - curves down between lights
  const wirePath = useMemo(() => {
    const lightPositions = lights.map((light) => light.position)
    const baseY = 0 // Middle of viewBox (viewBox height is 50)
    const droopAmount = 15 // Curve down by 10 pixels in viewBox coordinates
    return generateWirePath(lightPositions, baseY, droopAmount)
  }, [lights])

  return (
    <>
      <style>{`
        @keyframes twinkle {
          0%, 100% {
            opacity: 0.5;
            filter: drop-shadow(0 0 5px var(--glow-color)) brightness(0.5);
          }
          50% {
            opacity: 1;
            filter: drop-shadow(0 0 20px var(--glow-color)) brightness(2);
          }
        }
        .christmas-light {
          position: absolute;
          top: var(--y-position);
          left: var(--x-position);
          transform: translate(-50%, -50%);
          user-select: none;
          pointer-events: none;
          animation: twinkle var(--twinkle-speed) ease-in-out infinite;
          animation-delay: var(--twinkle-delay);
          will-change: filter, opacity;
        }
        .christmas-light-svg {
          display: block;
        }
        .christmas-wire {
          stroke:rgb(8, 11, 19);
          stroke-width: 1;
          fill: none;
          opacity: 1;
        }
      `}</style>
      <HolidayPortal>
        <div className="pointer-events-none fixed top-14 left-0 z-50 h-[30px] w-screen overflow-visible">
          {lights.map((light) => (
            <div
              className="christmas-light"
              key={light.id}
              style={
                {
                  '--x-position': `${light.position}%`,
                  '--y-position': `${lightYPosition}%`,
                  '--glow-color': light.glowColor,
                  '--twinkle-speed': `${light.twinkleSpeed}s`,
                  '--twinkle-delay': `${light.twinkleDelay}s`,
                } as React.CSSProperties
              }
            >
              <SnowflakeSVG color={light.color} glowColor={light.glowColor} size={light.size} type={light.type} />
            </div>
          ))}
          <svg
            aria-label={t('Christmas Wire')}
            className="absolute top-0 left-0 h-full w-full"
            preserveAspectRatio="none"
            viewBox="0 0 100 50"
          >
            <title>{t('Christmas Wire')}</title>
            <path className="christmas-wire" d={wirePath} />
          </svg>
        </div>
      </HolidayPortal>
    </>
  )
}

export default ChristmasLightEffect
